export default "__VITE_ASSET__ic62LSY2__"